import { items } from './config';

export function isPathActive(pathname, path) {
  if (!path) {
    return false;
  }
  if (path === '/') {
    return pathname === '/';
  }
  return pathname === path || pathname.startsWith(`${path}/`);
}

export function getVisibleSections(role) {
  return items
    .map((item, index) => {
      const children = item.children?.filter((child) => child.roles?.includes(role)) || [];
      const canView = item.roles?.includes(role) || children.length > 0;

      if (!canView) {
        return null;
      }

      return {
        key: `${item.title}-${index}`,
        title: item.title,
        icon: item.icon,
        path: children[0]?.path || item.path,
        children,
      };
    })
    .filter(Boolean);
}

export function isSectionActive(section, pathname) {
  if (section.children.length > 0) {
    return section.children.some((child) => isPathActive(pathname, child.path));
  }
  return isPathActive(pathname, section.path);
}

export function findActiveSection(sections, pathname) {
  return sections.find((section) => isSectionActive(section, pathname)) || null;
}
